<template>
  <div class="payroll__breakdown">
    <div class="payroll__breakdown--alert">
      <div class="payroll__breakdown--alert-icon">
        <img src="./../../../assets/images/preview.png" alt />
      </div>
      <div class="payroll__breakdown--alert-text">
        <span>A Quick Preview Before You Submit</span>
        <p>
          Please spend a brief moment reviewing these numbers before you submit
          payroll. As a reminder, Your employees will be paid on your chosen
          payment date.
          <br />
          <br />Payroll transaction charge is &#8358;{{
            summaryData.transactionCost
          }}
          per transaction.
        </p>
        <div class="payroll__preview--warning">
          <div class="payroll__breakdown--alert-text-icon">
            <img src="./../../../assets/images/warning.png" alt />
          </div>
          <div class="payroll__breakdown--alert-text-para">
            After you review and submit this payroll, we will debit &#8358;{{ totalChargeWithVAT }}
            from your account. The total employee take-home amount is &#8358;{{
              summaryData.totalNetAmount | addKoboToValue
            }}, with a transaction charge of &#8358;{{ summaryData.totalCost }}
            plus VAT at 7.5%. Please ensure that these funds are available in your account.
            If everything is correct, proceed to submit the payroll.
          </div>
        </div>

        <div class="payroll__preview--details">
          <!-- Existing details sections -->
        </div>
      </div>
    </div>

    <div class="payroll__breakdown--btns">
      <p>Don't worry, we aren't sending anything until the last step.</p>
      <span v-show="errorMessage">{{ errorMessage }}</span>
      <div>
        <div class="payroll__breakdown--btns-save" v-show="btnLoader">
          <WhiteLoader />
        </div>
        <div
          class="payroll__breakdown--btns-save"
          @click="savePreview"
          v-show="!btnLoader"
        >
          Submit
        </div>
        <div class="payroll__breakdown--btns-cancel" @click="closePreview">
          Cancel
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import WhiteLoader from "../../partials/white-loader";
import { addKoboToValue, payrollValueToCurrency } from "../../../util/filters";

export default {
  name: "PayrollPreview",
  components: {
    PageLoader,
    WhiteLoader,
  },
  data() {
    return {
      errorMessage: null,
      home: false,
      transact: false,
      pageLoader: false,
      btnLoader: false,
      summaryData: {},
    };
  },
  computed: {
    totalChargeWithVAT() {
      const totalCost = this.summaryData.totalCost || 0;
      const vat = 0.075;
      return (totalCost * (1 + vat)).toFixed(2);
    },
  },
  methods: {
    savePreview() {
      this.errorMessage = null;
      this.btnLoader = true;

      if (this.summaryData.payroll_id) {
        this.$http
          .post(types.PAYROLL_SUBMIT, {
            payroll_id: this.summaryData.payroll_id,
          })
          .then((resp) => {
            this.$store.state.summaryData.payroll_id =
              resp.data.data.payroll_uuid;
            this.$emit("clickedConfirm");
          })
          .catch((error) => {
            if (error.response.status === 400) {
              this.errorMessage = error.response.data.message;
            } else {
              this.errorMessage =
                "Unable to submit please restart the process.";
            }
            this.btnLoader = false;
          });
      } else {
        this.errorMessage = "Unable to submit please restart the process.";
      }
    },
    closePreview() {
      this.$router.push("/payroll/regular/initiate");
    },
    openHomeTable() {
      window.scrollTo({
        top: 650,
        left: 0,
        behavior: "smooth",
      });

      if (this.home) {
        this.home = false;
        this.transact = false;
      } else {
        this.home = true;
        this.transact = false;
      }
    },
    openTransactTable() {
      window.scrollTo({
        top: 650,
        left: 0,
        behavior: "smooth",
      });

      if (this.transact) {
        this.home = false;
        this.transact = false;
      } else {
        this.home = false;
        this.transact = true;
      }
    },
  },
  mounted() {
    if (this.$store.state.summaryData) {
      this.summaryData = this.$store.state.summaryData;
    } else {
      this.$router.push("/payroll");
    }
  },
  filters: {
    addKoboToValue,
    payrollValueToCurrency,
  },
};
</script>

<style lang="scss" scoped>
.payroll__breakdown {
  margin-top: 20px;
  padding-top: 26px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  > .payroll__breakdown--alert {
    overflow: hidden;

    > .payroll__breakdown--alert-icon {
      float: left;
      width: 2.656vw;
    }

    > .payroll__breakdown--alert-text {
      float: left;
      width: calc(100% - 2.656vw);
      padding: 0 10px;
      text-align: left;

      > span {
        font-size: 1rem;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.07;
        letter-spacing: normal;
        text-align: left;
        color: #5099de;
      }

      > p {
        font-size: 1rem;
        font-weight: 200;
        max-width: 800px;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.46;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin-top: 25px;

        > span {
          color: #5099de;
          text-decoration: none;
        }
      }

      .payroll__preview--warning {
        margin-top: 20px;
        border-radius: 3px;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
        border: solid 2px #ffe7bd;
        background-color: #fff9f0;
        padding: 36px 1.615vw;
        width: 57.031vw;
        overflow: hidden;

        @media (max-width: 768px) {
          width: 20rem;
          padding: 2rem 1rem;
        }

        .payroll__breakdown--alert-text-icon {
          width: 1rem;
          float: left;
        }

        .payroll__breakdown--alert-text-para {
          width: calc(100% - 2.396vw);
          padding-left: 1.042vw;
          float: left;
          font-size: 1rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 2.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;

          @media (max-width: 768px) {
            text-align: center;
          }
        }
      }
    }
  }

  .payroll__breakdown--details {
    margin-top: 100px;
    padding: 0 20px;

    > .payroll__breakdown--details-header {
      overflow: hidden;

      > .payroll__breakdown--details-header-name {
        width: 70%;
        float: left;
        display: flex;
        justify-content: center;
        flex-wrap: nowrap;

        > div {
          flex: 0 0 33.333333%;
          font-size: 1rem;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          padding-top: 10px;
        }
      }

      > .payroll__breakdown--details-header-btn {
        width: calc(100% - 70%);
        max-width: 210px;
        float: right;
        overflow: hidden;
        padding: 0 10px;

        > div {
          height: 38px;
          border-radius: 2px;
          background-color: #5099de;
          font-size: 1rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.19;
          letter-spacing: normal;
          color: #ffffff;
          text-align: center;
          padding-top: 10px;
          cursor: pointer;
        }
      }
    }

    .payroll__breakdown--details-body {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      border-top: 5px solid #5099de;
      margin-top: 42px;
      padding-bottom: 45px;

      > .payroll__breakdown--details-body-header {
        overflow: hidden;
        padding-top: 16px;
        padding-bottom: 85px;

        > .payroll__breakdown--details-body-header-name {
          width: 70%;
          float: left;
          display: flex;
          justify-content: center;
          flex-wrap: nowrap;

          > div {
            flex: 0 0 33.333333%;
            font-size: 1rem;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            padding-left: 50px;
            padding-top: 10px;
          }
        }

        > .payroll__breakdown--details-body-header-btn {
          width: calc(100% - 70%);
          float: right;
          overflow: hidden;
          overflow: hidden;

          > .payroll__breakdown--details-body-header-skip {
            width: 70%;
            float: left;
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: left;
            color: #5099de;
            padding-top: 12px;
          }

          > .payroll__breakdown--details-body-header-less {
            width: 30%;
            float: left;
            padding-top: 5px;

            > div {
              width: 70%;
              height: 8px;
              background-color: #f17d6b;
              margin: auto;
            }

            > p {
              font-size: 1.2rem;
              font-weight: 300;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.31;
              letter-spacing: normal;
              text-align: left;
              color: #f17d6b;
              text-align: center;
            }
          }
        }
      }

      > .payroll__breakdown--details-body-form {
        overflow: hidden;
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        padding-bottom: 107px;
        text-align: left;

        > .payroll__breakdown--details-body-form-compensation {
          flex: 2 0 33.3333333333%;
          overflow: hidden;
          padding-left: 50px;

          > span {
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: left;
            color: #777777;
            text-decoration: underline;
          }

          > div {
            padding-top: 46px;

            > .payroll__breakdown--name {
              width: 40%;
              float: left;
              font-size: 1.2rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.19;
              letter-spacing: normal;
              text-align: left;
              color: #707070;
              padding-top: 7px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }

            > .payroll__breakdown--input {
              width: 40%;
              float: left;
              position: relative;

              > input {
                height: 30px;
                border: solid 1px rgba(112, 112, 112, 0.5);
                background-color: #ffffff;
                outline: none;
                padding-left: 25px;
              }

              > div {
                position: absolute;
                top: 0;
                left: 0;
                width: 20px;
                height: 30px;
                border: 1px solid rgba(112, 112, 112, 0.5);
                text-align: center;
                padding-top: 5px;
                font-size: 1rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.19;
                letter-spacing: normal;
                color: #707070;
              }
            }

            > .payroll__breakdown--close {
              width: 20%;
              float: left;
              text-align: center;
              color: #f16b6f;
              padding-top: 5px;
            }
          }
        }

        > .payroll__breakdown--details-body-form-deductibles {
          flex: 2 0 33.3333333333%;
          overflow: hidden;
          padding-left: 50px;

          > span {
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: left;
            color: #777777;
            text-decoration: underline;
          }

          > div {
            padding-top: 46px;

            > .payroll__breakdown--name {
              width: 40%;
              float: left;
              font-size: 1.2rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.19;
              letter-spacing: normal;
              text-align: left;
              color: #707070;
              padding-top: 7px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }

            > .payroll__breakdown--input {
              width: 40%;
              float: left;
              position: relative;

              > input {
                height: 30px;
                border: solid 1px rgba(112, 112, 112, 0.5);
                background-color: #ffffff;
                outline: none;
                padding-left: 25px;
              }

              > div {
                position: absolute;
                top: 0;
                left: 0;
                width: 20px;
                height: 30px;
                border: 1px solid rgba(112, 112, 112, 0.5);
                text-align: center;
                padding-top: 5px;
                font-size: 1rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.19;
                letter-spacing: normal;
                color: #707070;
              }
            }

            > .payroll__breakdown--close {
              width: 20%;
              float: left;
              text-align: center;
              color: #f16b6f;
              padding-top: 5px;
            }
          }
        }

        > .payroll__breakdown--details-body-form-payable {
          flex: 2 0 33.3333333333%;
          overflow: hidden;
          padding-left: 50px;

          > span {
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: left;
            color: #777777;
            text-decoration: underline;
          }

          > div {
            padding-top: 46px;

            > .payroll__breakdown--name {
              width: 40%;
              float: left;
              font-size: 1rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.19;
              letter-spacing: normal;
              text-align: left;
              color: #707070;
              padding-top: 7px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }

            > .payroll__breakdown--input {
              width: 40%;
              float: left;
              position: relative;

              > input {
                height: 30px;
                border: solid 1px rgba(112, 112, 112, 0.5);
                background-color: #ffffff;
                outline: none;
                padding-left: 25px;
              }

              > div {
                position: absolute;
                top: 0;
                left: 0;
                width: 20px;
                height: 30px;
                border: 1px solid rgba(112, 112, 112, 0.5);
                text-align: center;
                padding-top: 5px;
                font-size: 1rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.19;
                letter-spacing: normal;
                color: #707070;
              }
            }

            > .payroll__breakdown--close {
              width: 20%;
              float: left;
              text-align: center;
              color: #f16b6f;
              padding-top: 5px;
            }
          }
        }
      }

      > .payroll__breakdown--details-body-fields {
        > div {
          max-width: 300px;
          margin: 0 auto;
          font-size: 1rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.19;
          letter-spacing: normal;
          text-align: center;
          color: #1ec4b4;
          cursor: pointer;
        }
      }
    }

    .payroll__breakdown--details-card {
      height: 67.5px;
      margin-top: 20px;
      margin-bottom: 22px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding-top: 25px;

      .payroll__breakdown--details-card-name {
        flex: 2 0 30%;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
      }

      .payroll__breakdown--details-card-gross {
        flex: 2 0 20%;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
      }

      .payroll__breakdown--details-card-amount {
        flex: 2 0 20%;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
      }

      .payroll__breakdown--details-card-skip {
        flex: 2 0 20%;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.19;
        letter-spacing: normal;
        text-align: center;
        color: #5099de;
      }

      .payroll__breakdown--details-card-close {
        flex: 2 0 10%;
        color: #f16b6f;
      }
    }
  }

  .payroll__breakdown--btns {
    margin-top: 4rem;
    // padding-top: 45px;
    padding-bottom: 9rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;

    > p {
      font-size: 1rem;
      font-weight: 200;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
      margin-bottom: 45px;
    }

    > span {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      margin: 1rem;

      @media (max-width: 768px) {
        text-align: center;
      }
    }

    > div {
      max-width: 20.833vw;
      margin: auto;
      overflow: hidden;

      .payroll__breakdown--btns-save {
        width: 9.375vw;
        height: 41px;
        float: left;
        border-radius: 3px;
        background-color: #5099de;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;

        @media (max-width: 768px) {
          width: 5rem;
          padding: 1.5rem;
        }
      }

      .payroll__breakdown--btns-load {
        width: 9.375vw;
        height: 41px;
        float: left;
        border-radius: 3px;
        background-color: #5099de;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;

        @media (max-width: 768px) {
          width: 4rem;
        }
      }

      .payroll__breakdown--btns-cancel {
        width: 9.375vw;
        height: 41px;
        float: right;
        border-radius: 3px;
        border: solid 1px #c7c7c7;
        background-color: #ffffff;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #777777;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;

        @media (max-width: 768px) {
          width: 4rem;
          margin-top: 0.5rem;
          float: left;
          margin-left: 0.5rem;
        }
      }
    }
  }
}

.payroll__breakdown--loader {
  margin-top: 50px;

  > div {
    width: 55px;
    margin: auto;
  }
}

.payroll__preview--details {
  margin-top: 44px;

  .payroll__preview--details-home {
    > p {
      font-size: 1rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: normal;
      text-align: left;
      color: #5099de;
      cursor: pointer;
    }
  }
}

.payroll__preview--details-header {
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  padding-bottom: 20px;

  > div {
    width: 20%;
    flex: 2 0 20%;
    font-size: 1rem;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    padding-left: 20px;
  }
}

.payroll__preview--details-body {
  border-top: 3px solid #5099de;
  border-bottom: 3px solid #5099de;

  > div {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    margin-bottom: 22px;
    overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;

    > div {
      flex: 2 0 20%;
      width: 20%;
      font-size: 1rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      padding: 20px 0 20px 20px;
    }
  }
}

.payroll__preview--details-footer {
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  padding-top: 34px;

  > div {
    width: 20%;
    flex: 2 0 20%;
    padding-left: 20px;
    font-size: 1rem;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #5099de;
  }
}

.payroll__breakdown--paginate {
  width: 300px;
  margin: 50px auto 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  border-radius: 4px;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
  border: solid 1px #d7dae2;
  background-color: #ffffff;

  > div {
    width: 20%;
    padding: 8px 0;
    text-align: center;
    font-size: 1rem;
    border: solid 1px #d7dae2;
    background-color: #ffffff;
    color: #000000;
  }

  > div:nth-child(3) {
    color: #000000;
    background-color: #ddd;
  }
}

.payroll__preview--details-total {
  text-align: right;
  margin-top: 60px;
  padding-right: 20px;

  > span {
    font-size: 2rem;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    color: #000000;
  }

  > p {
    font-size: 1rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.5;
    letter-spacing: normal;
    color: #707070;
    margin: 0;
  }
}
</style>
